import React from "react";
import "./CourseSection.css";

const CourseSection = () => {
  const careerPath = [
    {
      number: "01",
      title: "Learn the Fundamentals",
      description:
        "Build a strong foundation in programming, databases, problem solving and core development concepts.",
      tools: ["Java", "Python", "SQL"],
      image: "/images/Learning1.jpeg",
      icon: "⌘",
    },

    {
      number: "02",
      title: "Build Technical Skills",
      description:
        "Learn modern full stack technologies through structured training, hands-on practice and mentor guidance.",
      tools: ["React", "Spring Boot", "REST API"],
      image: "/images/Instructors1.webp",
      icon: "▣",
    },

    {
      number: "03",
      title: "Build Real Projects",
      description:
        "Apply your knowledge through practical, industry-oriented projects while building a strong development portfolio.",
      tools: ["Git", "GitHub", "Postman"],
      image: "/images/Mentors1.webp",
      icon: "▱",
    },

    {
      number: "04",
      title: "Interview Prep & Communication",
      description:
        "Develop communication and interview skills through JAM sessions, group discussions, mock interviews and presentation activities.",
      tools: ["JAM", "Group Discussion", "Mock Interviews"],
      image: "/images/PlacementPrep1.webp",
      icon: "◌",
    },

    {
      number: "05",
      title: "Industry Connect & Career Readiness",
      description:
        "Prepare for the professional world through industry sessions, career guidance, certification and placement readiness.",
      tools: ["Industry Sessions", "Certification", "Career Guidance"],
      image: "/images/PlacementReadiness.jpeg",
      icon: "◇",
    },
  ];

  return (
    <section className="career-pathway-section">

      {/* ================= HEADER ================= */}

      <div className="career-pathway-header">

        <span className="career-pathway-badge">
          STRUCTURED BLUEPRINT
        </span>

        <h2>
          The 5-Step Career Pathway to
          <span> Getting Hired</span>
        </h2>

        <p>
          From learning the fundamentals to building real projects,
          developing communication skills and becoming career-ready,
          follow a structured journey designed by PRT Academy.
        </p>

      </div>

      {/* ================= CAREER CARDS ================= */}

      <div className="career-pathway">

        {careerPath.map((item) => (

          <article
            className="career-step"
            key={item.number}
          >

            {/* TOP */}

            <div className="career-step-top">

              <div className="career-step-icon">
                {item.icon}
              </div>

              <span className="career-step-number">
                {item.number}
              </span>

            </div>

            {/* IMAGE */}

            <div className="career-step-image">

              <img
                src={item.image}
                alt={item.title}
              />

            </div>

            {/* CONTENT */}

            <div className="career-step-content">

              <h3>
                {item.title}
              </h3>

              <p>
                {item.description}
              </p>

            </div>

            {/* TOOLS */}

            <div className="career-tools">

              {item.tools.map((tool) => (

                <span
                  key={tool}
                  className="career-tool"
                >
                  {tool}
                </span>

              ))}

            </div>

            {/* MILESTONE */}

            <div className="career-milestone">

              <span className="milestone-check">
                ✓
              </span>

              <span>
                Phase {item.number} Milestone
              </span>

            </div>

          </article>

        ))}

      </div>

    </section>
  );
};

export default CourseSection;